module.exports = __webpack_public_path__ + "static/media/WandaLogoFull.356674ad.svg";